import React from 'react';

function navHeader() {
  return (
    <div className='container'>
      <div className='jumbotron '>
        <h1 style={{ textAlign: 'center' }}>Employee Directory</h1>
      </div>
    </div>
  );
}

export default navHeader;
